import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { UncontrolledTooltip } from "reactstrap";
import cx from "classnames";
import { ProductConfiguratorModal } from "components/_Modals/ProductConfiguratorModal";
import { ProductListModal } from "components/_Modals/ProductListModal";
import { useTranslate } from "hooks";
import NiceModal from "@ebay/nice-modal-react";
import {
  usePossibleTopologyActions,
  useSubType,
  useTopology,
} from "stores/wizardStore";
import type { OrderCode } from "interfaces/product/product.types";
import type { Accessory } from "interfaces/product/accessory/accessory.types";
import type { MenuItem } from "interfaces/product/topology/topology.types";
import { Button } from "../Button";
import type { IconName } from "components/Icon/iconNames";
import s from "./SummaryListItem.module.scss";

const actionsIconNames: Record<number, IconName> = {
  1: "configure-regular",
};

interface SummaryListItemIconBtnProps {
  id: string;
  title: string;
  orderCode: OrderCode;
  dummy: string;
  type: string;
  menuItem: MenuItem;
  handleBackAction: () => void;
  selectedAccessories: Accessory[];
  groupPosition: number;
}

export const SummaryListItemIconBtn: React.FC<SummaryListItemIconBtnProps> =
  Scrivito.connect(
    ({
      id,
      orderCode = {},
      dummy,
      type,
      menuItem,
      title,
      handleBackAction,
      selectedAccessories,
      groupPosition,
    }) => {
      const translate = useTranslate();

      const subType = useSubType();
      const topology = useTopology();
      const topologyActions = usePossibleTopologyActions();

      if (menuItem.enabled !== true) {
        return null;
      }

      if (!actionsIconNames[menuItem.id] || !topologyActions) {
        return null;
      }

      const { action, title: actionTitle } = topologyActions[menuItem.id];

      const handleClick = useCallback(() => {
        if (action === "configureComponent") {
          const isConfiguredProduct =
            "seriesId" in orderCode && orderCode.seriesId;

          if (isConfiguredProduct && subType) {
            NiceModal.show(ProductConfiguratorModal, {
              wizardArgs: {
                seriesId: orderCode.seriesId,
                groupPosition,
                wizardType: subType,
                dummyType: dummy,
                nodeId: id,
              },
              cleanupOnClose: true,
              handleBack: handleBackAction,
            });
          } else {
            NiceModal.show(ProductListModal, {
              id,
              orderCode,
              title,
              dummy,
              wizardType: subType,
              type,
              handleBackAction,
              topology,
              selectedAccessories,
              groupPosition,
            });
          }
        }
      }, [
        action,
        orderCode,
        id,
        handleBackAction,
        groupPosition,
        subType,
        dummy,
        title,
        type,
        topology,
        selectedAccessories,
      ]);

      return (
        <div
          className={cx(
            "border-1 border-left border-gray-300 px-0.5 d-flex  justify-content-center w-5",
            s.item_list,
          )}
        >
          <Button
            data-testid={`${id}Icon`}
            square={true}
            color="tertiary"
            icon={actionsIconNames[menuItem.id]}
            iconClassName="icon-16"
            classNames="p-0 border-0 cursor-pointer bg-transparent"
            id={`IconTag-${id}`}
            onClick={handleClick}
          />
          {/* Item translation to be provided by b.e */}
          <UncontrolledTooltip target={`IconTag-${id}`} placement="top">
            {translate(actionTitle)}
          </UncontrolledTooltip>
        </div>
      );
    },
  );
